/**
 * Settings 동기화 매핑 정의 (Single Source of Truth)
 *
 * 서버 동기화에 사용하는 키 목록을 정의한다.
 * Phase 2 이후 Redux 구조가 서버 카테고리 구조와 일치하므로 FLAT_KEY_TO_CATEGORY 불필요.
 *
 * - SETTINGS_ALLOWED_KEYS: 서버 전송 가능한 SettingsState 최상위 키 (whitelist)
 * - CALENDAR_EXCLUDED_KEYS: calendar 카테고리 내 로컬 전용 필드 (서버 미전송)
 * - TODO_EXCLUDED_KEYS: todo 카테고리 내 로컬 전용 필드 (서버 미전송)
 *
 * settingsMigration(store/settings/sagas.ts)에서도 동일 상수를 import하여
 * localSettings.calendar / localSettings.todo로 분리한다.
 */

/**
 * 서버 동기화에 허용된 최상위 Redux key (whitelist).
 * 이 key들만 prepareForSend(), setSettingsProvider()에서 처리된다.
 * 그 외의 최상위 key(localSettings, eTag 등)는 모두 무시된다.
 * 서버 스키마(server-setting.schema.json)의 setting properties와 일치해야 한다.
 */
export const SETTINGS_ALLOWED_KEYS: Set<string> = new Set([
  'version',
  'email',
  'account',
  'ai',
  'calendar',
  'todo',
  'general',
])

/**
 * calendar 객체 내에서 동기화 제외할 필드 (= 로컬 전용 필드).
 * - prepareForSend(): calendar 변환 시 제거한다.
 * - settingsMigration(): localSettings.calendar로 분리한다.
 */
export const CALENDAR_EXCLUDED_KEYS: Set<string> = new Set([
  'calendarViewType',
  'taskDrawerOpen',
  'lastAddedCalendar',
  'primaryTimezone',
  'primaryTimezoneLabel',
])

/**
 * todo 객체 내에서 동기화 제외할 필드 (= 로컬 전용 필드).
 * - prepareForSend(): todo 변환 시 제거한다.
 * - settingsMigration(): localSettings.todo로 분리한다.
 */
export const TODO_EXCLUDED_KEYS: Set<string> = new Set([
  'filterType',
  'sortBy',
  'sortDirection',
  'collapsedSectionKeys',
  'lastAddedFolder',
])
